/**
 * Estados del perfil Médico por cuenta, tal como los devuelve el endpoint
 * GET /v2/usuarios/{id}/empresas (campo `medico`). Son conceptos distintos de
 * los estados de la cuenta ("Activo" | "Pendiente").
 */
export const MEDICO_ESTADOS = {
  SI: 'Si',
  NO: 'No',
  DDJJ_PENDIENTE: 'DDJJ pendiente',
  DDJJ_PENDIENTE_APROBACION: 'DDJJ pendiente de aprobación',
}

/**
 * Estado del Badge (variant="dot") para cada estado del perfil Médico.
 */
export const MEDICO_BADGE_STATE = {
  [MEDICO_ESTADOS.SI]: 'success',
  [MEDICO_ESTADOS.NO]: 'neutral',
  [MEDICO_ESTADOS.DDJJ_PENDIENTE]: 'warning',
  [MEDICO_ESTADOS.DDJJ_PENDIENTE_APROBACION]: 'error',
}

/**
 * Indica si la cuenta tiene perfil Médico asignado (cualquier estado distinto de "No").
 * @param {string} medico - Estado del perfil médico de la cuenta
 * @returns {boolean}
 */
export const tienePerfilMedico = (medico) => Boolean(medico) && medico !== MEDICO_ESTADOS.NO

/**
 * Indica si el ícono "Subir documento" debe estar habilitado para la cuenta:
 * solo cuando el perfil médico está asignado y la DDJJ todavía no se subió.
 * @param {string} medico - Estado del perfil médico de la cuenta
 * @returns {boolean}
 */
export const puedeSubirDocumento = (medico) => medico === MEDICO_ESTADOS.DDJJ_PENDIENTE
